/**
 * 认证工具函数
 */

const TOKEN_KEY = 'token'

/**
 * 获取 token
 * @returns {string} token 字符串，如果不存在则返回空字符串
 */
export function getToken() {
    return localStorage.getItem(TOKEN_KEY) || ''
}

/**
 * 设置 token
 * @param {string} token token 字符串
 */
export function setToken(token) {
    localStorage.setItem(TOKEN_KEY, token)
}

/**
 * 移除 token
 */
export function removeToken() {
    localStorage.removeItem(TOKEN_KEY)
}

/**
 * 检查是否有 token
 * @returns {boolean} 是否存在 token
 */
export function hasToken() {
    return !!getToken()
}
